import React, { Component } from 'react';
import hoistStatics from 'hoist-non-react-statics';

export const AccountContext = React.createContext(null);

const getDisplayName = name => `withAccount(${name})`;

/**
 * Wraps any compponent and provides the `currentAccount` prop.
 *
 * @param {*} WrappedComponent
 */
export const withAccount = (WrappedComponent) => {
  const Context = AccountContext;
  const displayName = getDisplayName(WrappedComponent.displayName || WrappedComponent.name || 'Component');

  class WithAccountComponent extends Component {
    renderWrappedComponent = value => <WrappedComponent {...this.props} currentAccount={value} />;

    render() {
      return <Context.Consumer>{this.renderWrappedComponent}</Context.Consumer>;
    }
  }

  WithAccountComponent.WrappedComponent = WrappedComponent;
  WithAccountComponent.displayName = displayName;

  return hoistStatics(WithAccountComponent, WrappedComponent);
};
